// extracted by mini-css-extract-plugin
export var aircallIframe = "_ia-3";
export var fabContainer = "_ia-5";
export var fabRinging = "_ia-6";
export var loadingOverlay = "_ia-4";
export var pulse = "_ia-7";
export var widgetContent = "_ia-2";
export var widgetPanel = "_ia-0";
export var widgetPanelExpanded = "_ia-1";